'use client';

import { FC } from 'react';

import { Chat } from '../Chat/Chat';
import { Recaptcha } from '../Recaptcha/Recaptcha';

/**
 * Load third party libraries such as LiveChat or Recaptcha
 */
export const ThirdPartyLibraries: FC = () => (
  <>
    <Chat />
    <Recaptcha />
  </>
);
